import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { intlShape, injectIntl } from 'react-intl';

import Hidden from '@material-ui/core/Hidden';
import Fab from '@material-ui/core/Fab';

import PanelInfo from '../../labels/PanelInfo';
import Menu from './Menu';
import NewCommunications from './NewCommunications';
import DetailCommunication from './DetailCommunication';
import DetailMessage from './DetailMessage';
import { AddIcon } from '../../../images/icons/WrapSvg';
import Loading from '../../dialogs/loading';
import Error from '../../dialogs/Error';
import Snackbar from '../../labels/Snackbar';

import * as actions_messages from '../../../actions/messages.actions';
import * as actions_communications from '../../../actions/communications.actions';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: ''
        }
    }

    static getDerivedStateFromProps(props, state) {
        const { param, receive, sent, isnew, messages_is_loading, messages_has_errored, communications_has_errored, communications_is_loading } = props;
        if (param !== state.param ||
            receive !== state.receive ||
            sent !== state.sent ||
            isnew !== state.isnew) {

            state.param = param;
            state.receive = receive;
            state.sent = sent;
            state.isnew = isnew;
            state.messages_is_loading = messages_is_loading;
            state.messages_has_errored = messages_has_errored;
            state.communications_has_errored = communications_has_errored;
            state.communications_is_loading = communications_is_loading;

            return state;
        }
        return null;
    }

    handleClick = () => {
        this.props.history.push('/communications/sent/new');
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }   
    };

    handleClose = () => {
        this.setState({ error: undefined });
    }

    showError = (message, type) => {
        this.setState({ error: message, errorType: type });
    }

    render() {

        const { error, errorType } = this.state;
        const {
            param,
            receive,
            sent,
            isnew,
            messages_is_loading,
            messages_has_errored,
            communications_has_errored,
            communications_is_loading,
            communications_filter
        } = this.props;

        if (messages_has_errored.hasErrored) {
            return (
                <Error
                    open
                    type={messages_has_errored.hasErrored} 
                    message={messages_has_errored.error}
                    handleClose={this.handleBack}
                />
            );
        } else if (communications_has_errored.hasErrored) {
            return (
                <Error
                    open
                    type={communications_has_errored.hasErrored} 
                    message={communications_has_errored.error}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ?  errorType : "error" }
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}
                    {(messages_is_loading || communications_is_loading) && <Loading open opacity />}
                    {(param || isnew)
                        ?
                        <Hidden xsDown>
                            <div
                                className={
                                    'flex_50 overflow_y_scroll height100  shadow_right_on_tablet bg_white'
                                }
                                onScroll={this.handleScroll}
                            >
                                <Menu {...this.props} filter={communications_filter} />
                            </div>
                        </Hidden>
                        :
                        <div
                            className={
                                'flex_50 overflow_y_scroll height100  shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu {...this.props} filter={communications_filter} />
                        </div>
                    }
                    {isnew &&
                        <NewCommunications {...this.props} isNew showError={this.showError} />
                    }
                    {(param && sent) &&
                        <DetailCommunication {...this.props} showError={this.showError} />
                    }
                    {(param && receive) &&
                        <DetailMessage {...this.props} showError={this.showError} />
                    }
                    {!(param || isnew) &&
                        <PanelInfo is50={true} id={'manage_aux_message'} />
                    }
                    {!(param || isnew) && (
                        <Fab
                            color="primary"
                            aria-label="add"
                            className={'button_float'}
                            onClick={(e) => this.handleClick(e)}
                        >
                            <AddIcon />
                        </Fab>
                    )}

                </div>
            );
        }
    }
}

Index.propTypes = {
    intl: intlShape.isRequired
};

function mapStateToProps(state) {
    return {
        info: state.info,
        message: state.message,
        messages_is_loading: state.messages_is_loading,
        messages_has_errored: state.messages_has_errored,
        communications_is_loading: state.communications_is_loading,
        communications_has_errored: state.communications_has_errored,
        communication: state.communication,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions_messages, actions_communications), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)));



// WEBPACK FOOTER //
// ./src/components/complex/communications/Index.js